// extracted by mini-css-extract-plugin
export var popper = "_8i-0";